import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { Component, OnInit } from "@angular/core";
import { EntendendoEntidadeService } from "../../../../services/entendendo-entidade.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../../services/auth.service";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { PerguntaService } from "../../../../services/pergunta.service";
import { TabelaDominioService } from "../../../../services/tabela-dominio.service";
import { QuestionarioUGRespostaService } from "../../../../services/questionarioug-resposta.service";
import { MatDialog } from "@angular/material/dialog";
import { MatGridListModule } from "@angular/material/grid-list";
import { UniversoAuditavelService } from "../../../../services/universo-auditavel.service";
import {
  IUniversoAuditavelItemRespostaItensModel,
  IUniversoAuditavelModel
} from "../../../../models/universo-auditavel.model";
import { ITipoUniversoModel } from "../../../../models/tipo-universo.model";
import { TipoUniversoService } from "../../../../services/tipo-universo.service";
import { UnidadeGestoraService } from "../../../../services/unidade-gestora.service";
import { UniversoAuditavelItemRespostaService } from "../../../../services/universo-auditavel-item-resposta.service";
import { MatTableDataSource } from "@angular/material/table";
import { QuestionarioUGItensResposta } from "../../../../models/questionario-ug.model";


@Component({
  selector: 'app-imprimir-universo-auditavel',
  templateUrl: './imprimir-universo-auditavel.component.html',
  styleUrls: ['./imprimir-universo-auditavel.component.scss']
})
export class ImprimirUniversoAuditavelComponent extends  BaseFormComponent implements OnInit{

  public modelUniversoAuditavel = {} as IUniversoAuditavelModel;
  unidadeGestoraNome: string = '';
  unidadeGestora: number;
  public modelTipoUniversoItens: IUniversoAuditavelItemRespostaItensModel = {} as IUniversoAuditavelItemRespostaItensModel;
  public modelTipoUniverso: ITipoUniversoModel = {} as ITipoUniversoModel;
  dataSource: MatTableDataSource<IUniversoAuditavelItemRespostaItensModel>;
  criterios: string[] = [];
  versao: number;
  dataFormatada : string;
  displayedColumns: string[] = ['subtipo', 'macroprocesso', 'processos', ...this.criterios];
  headerRows = ['header-row-grupo', 'header-row-detalhes'];
  displayedColumnsGrupo = ['grupo-agrupamento', 'grupo-indicador'];
  private renderTipoIds = new Set<number>();
  indicadorNome: string = '';
  colspanIdicador: number;
  constructor(
    toastr: ToastrService,
    route: ActivatedRoute,
    router: Router,
    localeService: BsLocaleService,
    private universoAuditavelService: UniversoAuditavelService,
    private tipoUniversoService: TipoUniversoService,
    private unidadeGestoraService: UnidadeGestoraService,
    private universoAuditavelItemService: UniversoAuditavelItemRespostaService,

    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  async ngOnInit() {
    const res = await this.universoAuditavelService.obterPorId(this.id);
    if ( res.sucesso){
      this.modelUniversoAuditavel = res.dados;
      this.versao = this.modelUniversoAuditavel.versao;
      this.dataFormatada = this.modelUniversoAuditavel.dataCriacaoFormatada.toString();
    }

    this.buscarTipoUniverso(this.modelUniversoAuditavel.tipoUniversoAuditavelId);

  }

  public async buscarTipoUniverso(idTipo: number){
    const res = await this.tipoUniversoService.obterPorId(idTipo);
    if(res.sucesso){
      this.modelTipoUniverso =  res.dados;
      this.unidadeGestora  = this.modelUniversoAuditavel.unidadeGestoraId;
      this.titulo = 'Visualizar Mapeamento Universo Auditável - '+ this.modelTipoUniverso.nome;

      const unidade = await this.unidadeGestoraService.obterPorId(this.unidadeGestora);

      if (unidade.sucesso) {
        this.unidadeGestoraNome = unidade.dados.sigla + '-' + unidade.dados.nome;
      }
    }

    this.buscarItens(this.modelTipoUniverso.id, this.unidadeGestora);
  }

  public async buscarItens(idTipoUniverso: number, idUG: number) {
    if (idTipoUniverso) {
      const res = await this.universoAuditavelItemService.ObterRespostaPorCriterios(idUG, idTipoUniverso, this.modelUniversoAuditavel.id);
      if (res.sucesso) {
        this.modelTipoUniversoItens = res.dados;
        await this.reordenar();
        await  this.processData();

      }
    }
  }

  public async  reordenar() {
    // Verifica se model é um objeto com as chaves e percorre as chaves
    Object.keys(this.modelTipoUniversoItens).forEach((key, idx) => {
      this.reordenarItem(this.modelTipoUniversoItens[key], idx + 1, '');  // Começa a ordem com uma string vazia
    });
  }

  reordenarItem(item: IUniversoAuditavelItemRespostaItensModel, index: number, prefixo: string) {
    const novaOrdem = prefixo ? `${prefixo}.${index}` : `${index}`;
    item.ordemExibicao = novaOrdem;

    if (item.itens && Object.keys(item.itens).length > 0) {
      Object.keys(item.itens).forEach((key, idx) => {
        this.reordenarItem(item.itens[key], idx + 1, novaOrdem);
      });
    }
  }

  getStatusClass( modelUniversoAuditavel: IUniversoAuditavelModel): string {
    if (!modelUniversoAuditavel.ativo) {
      return 'inativo';
    }
    return modelUniversoAuditavel.status === 'Finalizado' ? '' : 'minuta';
  }

 async processData() {
    if (!this.modelTipoUniversoItens || Object.keys(this.modelTipoUniversoItens).length === 0) {
      this.dataSource.data = [];
      return;
    }
    const criteriosSet = new Set<string>();

    Object.values(this.modelTipoUniversoItens).forEach((value, idx) => {
      this.processItemsForCriterios(value, criteriosSet);
    });

    this.criterios = Array.from(criteriosSet);
    Object.values(this.modelTipoUniversoItens).forEach((value, idx) => {
      if(idx === 0){
        this.indicadorNome = value.indicadorDescricao;
      }
    });
    this.colspanIdicador = this.criterios.length ;


    this.displayedColumns = [
      'subtipo',
      'macroprocesso',
      'processos',
      ...this.criterios.map(c => `criterio_${c}`)
    ];

    this.dataSource = new MatTableDataSource<IUniversoAuditavelItemRespostaItensModel>(Object.values(this.modelTipoUniversoItens));

    // this.dataSource = Object.values(this.modelTipoUniversoItens);


  }
  processItemsForCriterios(item: IUniversoAuditavelItemRespostaItensModel, criteriosSet: Set<string>) {
    if (item.criterioNome) {
      criteriosSet.add(item.criterioNome);
    }

    if (item.itens && Object.values(item.itens).length > 0) {
      Object.values(item.itens).forEach(value => {
        this.processItemsForCriterios(value, criteriosSet);
      });
    }
  }

  getDivididosPorColunas(itemMacro: any) {
    const processos = itemMacro.itens.filter(
      processo => processo.idItemPai === itemMacro.tipoUniversoAuditavelItemId
    );

    const coluna1 = processos.slice(0, Math.ceil(processos.length / 2));
    const coluna2 = processos.slice(Math.ceil(processos.length / 2));

    return [coluna1, coluna2];
  }
  renderTipoNome(processo: any, itemMacro: any): boolean {
    if (!this.renderTipoIds.has(itemMacro.tipoUniversoAuditavelItemId)) {
      this.renderTipoIds.clear();  // Limpa o Set para este novo itemMacro
      this.renderTipoIds.add(itemMacro.tipoUniversoAuditavelItemId); // Marca este item como processado
    }

    if (this.renderTipoIds.has(processo.tipoUniversoAuditavelItemId)) {
      return false;
    } else {
      this.renderTipoIds.add(processo.tipoUniversoAuditavelItemId);
      return true;
    }
  }
  getCriterioValue(element: IUniversoAuditavelItemRespostaItensModel, criterioNome: string): string[] {
    let respostas: string[] = [];

    if (element.itens.length > 0) {
      for (const value of element.itens) {
        const respostasEncontradas = value.itens
          .filter(resp => value.tipoUniversoAuditavelItemId === resp.idItemPai && resp.criterioNome === criterioNome)
          .map(resp => resp.universoAuditavelItemRespostas);

        respostas.push(...respostasEncontradas);
      }
    }

    return respostas; // Retorna um array de respostas
  }

  print(): void {
    window.print();
  }

  public onBack() {
    this.submit = false;
    this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestora}?aba=3`);
  }
}
